import { DateUtils } from '../../utils/DateUtils';
import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { SshHandshake } from '../models/SshHandshake';
import { AlgorithmSupportInfo } from '../models/valueObjects/AlgorithmSupportInfo';
import { ClientServerInfo } from '../models/valueObjects/ClientServerInfo';

export class SshHandshakeMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): SshHandshake {
    return new SshHandshake(
      this.gqlIdEncoder.decode(data.id),
      data.initiatorIp,
      data.targetIp,
      data.initiatorPort,
      data.targetPort,
      data.timestamp ? DateUtils.toMoment(data.timestamp) : null,
      data.status,
      new AlgorithmSupportInfo(data.clientSupportedKexAlgs, data.serverSupportedKexAlgs, data.selectedKexAlg),
      new AlgorithmSupportInfo(data.clientSupportedServerHostkeyAlgs, data.serverSupportedServerHostkeyAlgs, data.selectedServerHostkeyAlg),
      new AlgorithmSupportInfo(data.clientSupportedMacC2sAlgs, data.serverSupportedMacC2sAlgs, data.selectedMacC2sAlg),
      new AlgorithmSupportInfo(data.clientSupportedMacS2cAlgs, data.serverSupportedMacS2cAlgs, data.selectedMacS2cAlg),
      new AlgorithmSupportInfo(data.clientSupportedSymencC2sAlgs, data.serverSupportedSymencC2sAlgs, data.selectedSymencC2sAlg),
      new AlgorithmSupportInfo(data.clientSupportedSymencS2cAlgs, data.serverSupportedSymencS2cAlgs, data.selectedSymencS2cAlg),
      new ClientServerInfo(data.clientProtocolVersion, data.serverProtocolVersion),
      new ClientServerInfo(data.clientSoftwareVersion, data.serverSoftwareVersion),
      new ClientServerInfo(data.clientSoftwareComments, data.serverSoftwareComments)
    );
  }
}
